"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
export var SliderTheme = /* @__PURE__ */ ((SliderTheme2) => {
  SliderTheme2["Light"] = "light";
  SliderTheme2["Dark"] = "dark";
  return SliderTheme2;
})(SliderTheme || {});
let Slider = class extends React.Component {
  constructor(props) {
    super(props);
    this.onInputChange = (event) => {
      const inputValue = Number(event.target.value);
      if (isNaN(inputValue) || this.isBelowMin(inputValue) || this.isAboveMax(inputValue)) {
        return;
      } else {
        this.props.onChange(inputValue);
      }
    };
    this.isBelowMin = (value) => {
      return this.props.minimum != void 0 && value < this.props.minimum;
    };
    this.isAboveMax = (value) => {
      return this.props.maximum != void 0 && this.props.maximum < value;
    };
  }
  render() {
    const { value, minimum, maximum, theme, stepSize, label, onMouseDown } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: "center-aligned", style: { width: "100%" } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        className: classNames({
          "slider-input__range-input": true,
          "slider-input__range-input--dark": theme === "dark" /* Dark */
        }),
        type: "range",
        min: minimum,
        max: maximum,
        onChange: this.onInputChange,
        value,
        step: stepSize,
        "aria-label": label,
        "aria-valuenow": value,
        "aria-valuemin": minimum,
        "aria-valuemax": maximum,
        "aria-orientation": "horizontal",
        onMouseDown
      }
    ));
  }
};
Slider.defaultProps = {
  minimum: 0,
  maximum: 100,
  theme: "light" /* Light */,
  stepSize: 1
};
Slider = __decorateClass([
  observer
], Slider);
export {
  Slider as default
};
